<template>
  <v-container class="location_select">
    <v-layout row wrap justify-space-between>
      <v-flex xs12 sm6 class="pr-2">
        <div class="head_lg">FROM</div>
        <v-select
          v-model="dep_loc"
					v-on:change="changeDep"
          :items="location_list"
          outline
          box
        ></v-select>
      </v-flex>
      <v-flex xs12 sm6 class="pr-2">
        <div class="head_lg">TO</div>
        <v-select
          v-model="dest_loc"
          :items="destinations"
          :key="dep_loc"
          outline
          box
        ></v-select>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import store from "../../../store";
import Shared from "@/mixins/Shared";
import { getField, updateField } from "vuex-map-fields";
import { createHelpers } from "vuex-map-fields";
const { mapFields } = createHelpers({
  getterType: "getField",
  mutationType: "updateField"
});

const getters = {
  getField
};

const mutations = {
  updateField
};

export default {
  name: "LocationSelect",
  mixins: [Shared],
  store: store,
  getters: getters,
	mutations: mutations,
	methods: {
		changeDep(a) {
			// console.log('changeDep', a);
			// check if destination is allowed for current depart log
			var matched = false;
			for (var x = 0; x < this.locations.length; x++) {
				if (this.locations[x].value == a && a > 0)
				{
					// current location
					// console.log('Searching for ' + this.locations[x].departs_to + ' in', this.locations[x].departs_to);
					for (var y = 0; y < this.locations[x].departs_to.length; y++)
					{
						if (this.locations[x].departs_to[y] == this.dest_loc)
						{
							// Found the currently selected destination is valid
							// for this new depart location as well, do nothing
							matched = true;
							// console.log('Found matching loc', this.locations[x].departs_to[y]);
						}
					}
					
				}
			}
			if (matched == false) {
				// Currently selected destination is not in the new departing
				// location. Clear the destination value from state
				// console.log('Destination selected is not valid from this departing location, resetting');
				this.dest_loc = 0;
				this.form_fields.dest_loc = 0;
				store.state.lowestFares['D'] = [];
				store.state.lowestFares['R'] = [];
			}
		}
	},
  computed: {
    ...mapFields([
      "form",
      "form_fields",
      "form_fields.dep_loc",
      "form_fields.dest_loc",
      "locations"
    ]),
    destinations() {
      let v = this.dep_loc;
      let tempObj = [];
      if (v > 0) {
        let loc = this.locations;
        for (var x = 0; x < loc.length; x++) {
          var match = false;
          for (var y = 0; y < loc[x].departs_to.length; y++) {
            if (loc[x].departs_to[y] == v) {
              match = true;
            }
          }
          if (match) {
            tempObj.push({
              text: loc[x].label,
              value: loc[x].value
            });
          }
        }
      }
      if (tempObj.length === 0) {
        return [{
          text: "----",
          value: 0
        }];
      }
      return tempObj;
    },
    location_list: function() {
      let loc = this.locations;
      let list = [];
      for (var x = 0; x < loc.length; x++) {
        list.push(
          {
            text: loc[x].label,
            value: loc[x].value
          }
        );
      }
      return list;
    }
  }
};
</script>
